<template>
  <div class="heading section-heading">
    <i v-if="icon.startsWith('icon')" class="icon" :class="icon"></i>
    <i v-else v-html="icon"></i>

    <span>{{ title }}</span>
  </div>
</template>

<script setup>
defineProps({
  icon: String,
  title: String,
})
</script>

<style lang="scss" scoped>
.heading {
  color: $brand-primary;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  grid-column: 1/-1;
  display: flex;
  gap: 16px;

  &:deep(svg) {
    width: 24px;
  }
}

.icon {
  font-size: 24px;
  color: $brand-tertiary;
}
</style>
